import { render } from "./ModalNewKpiChat.vue?vue&type=template&id=8622c798&scoped=true"
import script from "./ModalNewKpiChat.vue?vue&type=script&lang=js"
export * from "./ModalNewKpiChat.vue?vue&type=script&lang=js"

import "./ModalNewKpiChat.vue?vue&type=style&index=0&id=8622c798&scoped=true&lang=css"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8622c798"]])

export default __exports__